<template>
  <div class="c-email-app">
    <div class="c-body flex-row">
      <email-nav />
      <main class="c-main p-3">
        <p class="text-center">New Message</p>
        <form>
          <div class="form-row mb-3">
            <label for="to" class="col-2 col-sm-1 col-form-label">To:</label>
            <c-col cols="12" sm="11">
              <input id="to" type="email" class="form-control" placeholder="Type email" />
            </c-col>
          </div>
          <div class="form-row mb-3">
            <label for="cc" class="col-2 col-sm-1 col-form-label">CC:</label>
            <c-col cols="12" sm="11">
              <input id="cc" type="email" class="form-control" placeholder="Type email" />
            </c-col>
          </div>
          <div class="form-row mb-3">
            <label for="bcc" class="col-2 col-sm-1 col-form-label">BCC:</label>
            <c-col cols="12" sm="11">
              <input id="bcc" type="email" class="form-control" placeholder="Type email" />
            </c-col>
          </div>
        </form>
        <c-row>
          <c-col sm="11" class="ml-auto">
            <div class="toolbar" role="toolbar">
              <div class="btn-group mr-1">
                <c-button color="light"><c-icon name="cil-bold" /></c-button>
                <c-button color="light"><c-icon name="cil-italic" /></c-button>
                <c-button color="light"><c-icon name="cil-underline" /></c-button>
              </div>
              <div class="btn-group mr-1">
                <c-button color="light"><c-icon name="cil-align-left" /></c-button>
                <c-button color="light"><c-icon name="cil-align-right" /></c-button>
                <c-button color="light"><c-icon name="cil-align-center" /></c-button>
                <c-button color="light"><c-icon name="cil-justify-center" /></c-button>
              </div>
              <div class="btn-group mr-1">
                <c-button color="light"><c-icon name="cil-indent-increase" /></c-button>
                <c-button color="light"><c-icon name="cil-indent-decrease" /></c-button>
              </div>
              <div class="btn-group mr-1">
                <c-button color="light"><c-icon name="cil-list" /></c-button>
                <c-button color="light"><c-icon name="cil-list-numbered" /></c-button>
              </div>
              <c-button color="light" class="mr-1"><c-icon name="cil-trash" /></c-button>
              <c-button color="light"><c-icon name="cil-paperclip" /></c-button>
              <label-dropdown />
            </div>
            <div class="form-group mt-4">
              <textarea id="message" class="form-control" name="body" rows="12" placeholder="Click here to reply" />
            </div>
            <div class="form-group">
              <c-button class="mr-1" type="submit" color="success">Send</c-button>
              <c-button class="mr-1" type="submit" color="light">Draft</c-button>
              <c-button class="mr-1" type="submit" color="danger">Discard</c-button>
            </div>
          </c-col>
        </c-row>
      </main>
    </div>
  </div>
</template>

<script>
import EmailNav from './EmailNav';
import LabelDropdown from './LabelDropdown';

export default {
  name: 'Compose',
  components: {
    EmailNav,
    LabelDropdown,
  },
};
</script>
